import {
  httpGetAndParse,
  httpPostAndParse,
  httpPostFileAndParse,
} from '../../../utils/fetchService';
import stringify from '../../../utils/stringify';

export const uploadFileForGenericAccountDataUpload = ({
  taxYear,
  period,
  file,
  shouldReplaceAccountData,
  shouldAggregateData,
}) => {
  const body = new FormData();
  body.append('file', file);
  body.append('taxYear', taxYear);
  body.append('period', period);
  body.append('shouldReplaceAccountData', shouldReplaceAccountData);
  body.append('shouldAggregateData', shouldAggregateData);

  return httpPostFileAndParse({
    route: `/api/jim/generic-account-data-upload`,
    errorMessage: 'Uploading generic account data failed',
    body,
  });
};

export const fetchLastImportData = ({ hdrId, batchId, uniqueJobId, offset, sort }) =>
  httpGetAndParse({
    route: `/api/tools/generic-account-data/last-import?${stringify({
      hdrId,
      batchId,
      uniqueJobId,
      offset,
      sort,
    })}`,
    errorMessage: 'Fetching last import data failed',
  });

export const fetchLastImportAcceptedKeys = ({ hdrId }) =>
  httpGetAndParse({
    route: `/api/tools/generic-account-data/last-import-keys?${stringify({ hdrId })}`,
    errorMessage: 'Fetching last import keys failed',
  });

export const fetchLastImportStagedRows = ({ batchId, uniqueJobId }) =>
  httpGetAndParse({
    route: `/api/tools/generic-account-data/last-import-staged-rows?${stringify({
      batchId,
      uniqueJobId,
    })}`,
    errorMessage: 'Fetching last import staged rows failed',
  });

export const fetchInvalidOrgIds = ({ taxYear, period, orgIds }) =>
  httpPostAndParse({
    route: `/api/tools/generic-account-data/invalid-org-ids`,
    body: { taxYear, period, orgIds },
    errorMessage: 'Fetching invalid org ids failed',
  });

export const fetchLastFileUploadOn = ({ taxYear, period, excludeHdrId }) =>
  httpGetAndParse({
    route: `/api/tools/generic-account-data/last-file-upload-on?${stringify({
      taxYear,
      period,
      ...(excludeHdrId && { excludeHdrId }),
    })}`,
    errorMessage: 'Fetching last file upload time failed',
    suppressNotFoundPermissionModal: true,
  });

const GENERIC_ACCOUNT_DATA_UPLOAD_JOB_TYPE = 'generic-account-data-upload';

export const fetchUploadJobStatus = async ({ jobId }) => {
  try {
    return await httpGetAndParse({
      route: `/api/tools/generic-account-data/job-status/${jobId}`,
      suppressNotFoundPermissionModal: true,
    });
  } catch (toolsRouteError) {
    try {
      return await httpGetAndParse({
        route: `/api/jim/job/${GENERIC_ACCOUNT_DATA_UPLOAD_JOB_TYPE}/${jobId}?shouldCreateNotification=false`,
        suppressNotFoundPermissionModal: true,
      });
    } catch (jimRouteError) {
      if (toolsRouteError?.status === 404 || jimRouteError?.status === 404) {
        return null;
      }

      throw jimRouteError;
    }
  }
};
